import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'settingsStorage', // ключ в localStorage
  storage: localStorage,  // можно заменить на sessionStorage при желании
});

export const settingsState = atom({
  key: 'settingsState',
  default: {
    loginEnabled: true,
    registerEnabled: true,
    allowUserRequests: true,
    sndStatusesToUser: false,
    submissionOpen: true,
    submissionOpenYear: null,
  },
  effects_UNSTABLE: [persistAtom],
});
